import type {BioIconProps} from './common-types'

export function ThumbUpSignaturePickIcon({fill, ...attributes}: BioIconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M2.08984 15C2.64213 15 3.08984 14.5523 3.08984 14L3.08984 8C3.08984 7.44771 2.64213 7 2.08984 7C1.53756 7 1.08984 7.44771 1.08984 8L1.08984 14C1.08984 14.5523 1.53756 15 2.08984 15Z"
        fill="#1E40AF"
      />
      <path
        d="M5.7651 13H4.08965L4.08966 8C4.75253 8 5.30843 7.5336 5.64642 6.96337C5.97981 6.40091 6.44708 5.92717 7.00433 5.58603C7.48206 5.29357 7.91095 4.8797 7.99274 4.32557L7.99335 4.32132C8.03083 4.06658 8.05764 3.80838 8.0733 3.54717C8.08415 3.36621 8.08966 3.18369 8.08966 3C8.08966 2.55113 8.0568 2.10993 7.99335 1.67868C7.96492 1.48544 8.04119 1.28532 8.21687 1.19998C8.48062 1.07186 8.77674 1 9.08966 1C10.1942 1 11.0897 1.89555 11.0897 3.00012C11.0897 3.81187 11.0091 4.6048 10.8554 5.37133C10.7912 5.69168 11.0299 6 11.3566 6L13.0897 6C14.1942 6 15.1001 6.89759 14.9911 7.99676C14.9707 8.20221 14.9472 8.40675 14.9207 8.61035C14.7327 10.0566 14.3898 11.4534 13.9098 12.7844C13.6401 13.5322 12.9118 14 12.1169 14H9.41421C9.19925 14 8.98569 13.9653 8.78175 13.8974L6.39756 13.1026C6.19362 13.0347 5.98006 13 5.7651 13Z"
        fill="#1E40AF"
      />
    </svg>
  )
}
